export * from '@tanstack/query-core';

import { useCategoryTreeItem } from '../categoryTree';
import { KuxFilteredCategoriesDTO, UIDAPresentationTypeEnum } from '../compat/tvpil';

import { useCollection } from './useCollection';

function createMeta(category: KuxFilteredCategoriesDTO) {
  return {
    collectionId: category.channels[0],
    groupBy: category.subtype === UIDAPresentationTypeEnum.series_catch_up ? 'SeriesID' : category.groupBy,
    kSql: category.aggregatedKSQL,
    limit: category.railProperty.railItemsLimit,
  };
}

export function useRailCollection(referenceId: string, pageSize: number) {
  const category = useCategoryTreeItem(referenceId);

  return useCollection({
    referenceId,
    pageSize,
    meta: category ? createMeta(category) : undefined,
  });
}
